module.exports = __webpack_public_path__ + "img/kefu.027e7741.jpg";